import React from 'react';
import style from './MissionsRewardInfoBlock.scss';
import { Icon } from 'js/components/common/Icon';
import { usePortletTranslations } from '../../../../system/Portlet/hooks';
import classNames from '../../Details/classNames';

export const MissionsRewardInfoBlock = ({ mainText, prizeDescriptionText, isNotInCard }) => {

    const t = usePortletTranslations();
    return (
        <div className={classNames(style.wrapper, { [style.wrapperIsNotInCard]: isNotInCard })}>
            <div>
                <Icon type="missionsReward"/>
            </div>
            <div className={style.textWrapper}>
                <div className={style.headerTitle}>{t(mainText)}</div>
                <div className={style.rewardDescription}>{prizeDescriptionText}</div>
            </div>
        </div>
    );
};
